import React from "react";
import { motion } from "framer-motion";

export default function PageHeader({ overline, title, subtitle, image }) {
  return (
    <section className="relative grain overflow-hidden border-b border-white/10">
      {image && (
        <div className="absolute inset-0 z-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/60 via-[#0A0A0A]/80 to-[#0A0A0A]" />
        </div>
      )}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          {overline && <span className="font-accent text-[#00E5FF] text-sm">{overline}</span>}
          <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white mt-3 max-w-4xl">{title}</h1>
          {subtitle && <p className="text-neutral-400 text-base sm:text-lg mt-5 max-w-2xl leading-relaxed">{subtitle}</p>}
        </motion.div>
      </div>
    </section>
  );
}
